<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.addService.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'manageEvent.addService.requiredHint' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('manageEvent.addService.serviceName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'manageEvent.addService.serviceNamePlaceholder' | translate"
          [(value)]="event_service_name"
          [invalid]="isServiceNameInvalid"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'manageEvent.addService.availableSlots' | translate"
          [type]="'number'"
          [placeholder]="'manageEvent.addService.availableSlotsPlaceholder' | translate"
          [(value)]="max_num_registrations"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'manageEvent.addService.serviceDescription' | translate"
          [type]="'text'"
          [placeholder]="'manageEvent.addService.serviceDescriptionPlaceholder' | translate"
          [(value)]="event_service_description"
        />
      </div>
    </div>
    <!-- Pricing Section -->
    <div class="row g-4 spacing-15">
      <div class="col-12">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="isFreeService"
            [checked]="isFree"
            (change)="toggleFree($any($event.target).checked)"
          >
          <label class="form-check-label" for="isFreeService">
            {{ 'manageEvent.addService.freeService' | translate }}
          </label>
          <div class="form-text text-muted">{{ 'manageEvent.addService.freeServiceHint' | translate }}</div>
        </div>
      </div>
    </div>

    @if (!isFree) {
      <div class="row g-4">
        <div class="col-lg-4 col-12">
          <app-input-component
            [label]="'manageEvent.addService.price' | translate"
            [type]="'number'"
            [placeholder]="'manageEvent.addService.pricePlaceholder' | translate"
            [(value)]="price"
          />
          @if (price > 0) {
            <div class="text-muted small mt-1">
              {{ 'common.netAmountHint' | translate:{ amount: calculateNetAmount(price), currency: price_currency || 'NOK' } }}
            </div>
          }
        </div>
        <div class="col-lg-4 col-12">
          <app-selectorini
            [label]="'manageEvent.addService.priceCurrency' | translate"
            [options]="currencyOptions"
            [displayKey]="'name'"
            [valueKey]="'code'"
            [value]="price_currency"
            [disabled]="true"
          />
        </div>
        <div class="col-lg-4 col-12">
          <app-selectorini
            [label]="'manageEvent.addService.vat' | translate"
            [options]="vatRateOptions"
            [displayKey]="'label'"
            [valueKey]="'value'"
            [value]="vat_rate"
            (valueChange)="vat_rate = $event"
          />
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <app-button
      [variant]="'primary'"
      [size]="'md'"
      [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"
      [label]="saving ? ('manageEvent.addService.adding' | translate) : ('manageEvent.addService.addService' | translate)"
      [disabled]="saving"
      (clicked)="addEvent()"
    />
  </div>
</div>
